import React from 'react';
import { Alert } from 'reactstrap';

const Logout = (props) => {
  return <Alert color="success">Użytkownik został wylogowany.</Alert>;
};

export default Logout;
